import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faHourglassClock } from '@fortawesome/pro-light-svg-icons';

export type ProLightHourglassClockProps = IconComponentProps;

export const ProLightHourglassClock = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightHourglassClockProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faHourglassClock}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faHourglassClock}
    />
  );
};

ProLightHourglassClock.displayName = 'ProLightHourglassClock';
